import {
  Sparkles, DollarSign, BarChart3, Rocket, Zap, TrendingUp, Bell, Star,
  Package, Users, Clock, Calendar, Briefcase, Mail, ScrollText, Shield, Eye,
  ShoppingCart, CreditCard, FileText, Cloud, Database, Globe, Cpu, Lock,
  Smartphone, MessageSquare, PieChart
} from "lucide-react";

/**
 * Central registry of lucide-react icon keys the Super Admin can pick from
 * when creating a roadmap item. Keep this list curated — a huge dropdown is
 * worse than a short one.
 */
export const ROADMAP_ICON_OPTIONS = [
  { key: "sparkles", label: "Sparkles ✨" },
  { key: "dollar-sign", label: "Dollar Sign" },
  { key: "bar-chart-3", label: "Bar Chart" },
  { key: "pie-chart", label: "Pie Chart" },
  { key: "rocket", label: "Rocket" },
  { key: "zap", label: "Lightning" },
  { key: "trending-up", label: "Trending Up" },
  { key: "bell", label: "Bell" },
  { key: "star", label: "Star" },
  { key: "package", label: "Package" },
  { key: "users", label: "Users" },
  { key: "clock", label: "Clock" },
  { key: "calendar", label: "Calendar" },
  { key: "briefcase", label: "Briefcase" },
  { key: "mail", label: "Mail" },
  { key: "shopping-cart", label: "Shopping Cart" },
  { key: "credit-card", label: "Credit Card" },
  { key: "file-text", label: "File" },
  { key: "cloud", label: "Cloud" },
  { key: "database", label: "Database" },
  { key: "globe", label: "Globe" },
  { key: "cpu", label: "CPU" },
  { key: "lock", label: "Lock" },
  { key: "smartphone", label: "Smartphone" },
  { key: "message-square", label: "Message" },
];

const ICON_MAP = {
  "sparkles": Sparkles,
  "dollar-sign": DollarSign,
  "bar-chart-3": BarChart3,
  "pie-chart": PieChart,
  "rocket": Rocket,
  "zap": Zap,
  "trending-up": TrendingUp,
  "bell": Bell,
  "star": Star,
  "package": Package,
  "users": Users,
  "clock": Clock,
  "calendar": Calendar,
  "briefcase": Briefcase,
  "mail": Mail,
  "scroll-text": ScrollText,
  "shield": Shield,
  "eye": Eye,
  "shopping-cart": ShoppingCart,
  "credit-card": CreditCard,
  "file-text": FileText,
  "cloud": Cloud,
  "database": Database,
  "globe": Globe,
  "cpu": Cpu,
  "lock": Lock,
  "smartphone": Smartphone,
  "message-square": MessageSquare,
};

/**
 * Render the icon component for a given key. Falls back to Sparkles when the
 * key isn't registered so a mistyped icon in the DB never crashes the UI.
 */
export function RoadmapIcon({ iconKey, className = "w-5 h-5" }) {
  const Comp = ICON_MAP[iconKey] || Sparkles;
  return <Comp className={className} />;
}
